// extracted by css-extract-rspack-plugin
export default {"board-column-credits-wrapper":"board-column-credits-wrapper-c7FQZU","boardColumnCreditsWrapper":"board-column-credits-wrapper-c7FQZU"};